import EngraveTitle from "./EngraveTitle"

const InfoContainer = ({ children, title }) => {
  return (
    <>
      <section className="bg-[url('/src/assets/imgs/our-story/rachman-and-sons/section-cover.webp')]">
        <EngraveTitle title={title} custCls="mt-12" />
        <div className="w-[88%] sm:w-[78%] lg:w-[68%] mx-auto pb-24">
          {children}
        </div>
      </section>
    </>
  )
}

export default InfoContainer